<template>
  <template v-if="alwaysOpen">
    <div class="tw-pb-3 tw-pl-1 tw-pt-1">
      <template v-for="(item, index) in group.Items" :key="index">
        <div class="tw-relative">
          <Checkbox
            v-if="group.Type === 'Checkbox'"
            :item="item"
            :group="group"
            :name="item.Text"
            :index="index"
            @filter-change="emitFilterChange"
          ></Checkbox>
          <Radio
            v-if="group.Type === 'Radio'"
            :radioGroupName="group.Group"
            :group="group"
            :item="item"
            :index="index"
            :class="{ 'tw-mr-10': item.HelperText }"
            @filter-change="emitFilterChange"
          >
          </Radio>
          <Accordion
            :toggleClasses="[
              'tw-absolute',
              'tw-right-2',
              group.Group === 'ColorGroupName' ? 'tw-top-2' : 'tw-top-0',
            ]"
            @open="updateGroupAccordionHeight"
            v-if="item.HelperText"
          >
            <template #button-content="{ isExpanded, hovered }">
              <InformationCircleIcon
                class="tw-w-5 tw-h-5 tw-text-noraGray-200"
                :class="{
                  'tw-text-noraGray-600': isExpanded,
                  'tw-text-noraGray-400': hovered,
                }"
              />
            </template>

            <template #default>
              <p
                class="tw-text-xs"
                :class="{ 'tw-pl-6': group.Group !== 'ColorGroupName' }"
              >
                {{ item.HelperText }}
              </p>
            </template>
          </Accordion>
        </div>
      </template>
    </div>
  </template>

  <template v-else>
    <accordion
      :toggleClasses="'tw-ml-0 tw-w-full tw-border-t-solid tw-border-gray-100 tw-border-t-2 tw-py-2 tw-pr-2'"
      ref="groupAccordion"
    >
      <template
        #button-content="{ focus, hovered, isExpanded }"
        v-if="!alwaysOpen"
      >
        <span class="tw-flex tw-items-center tw-justify-between">
          <span
            class="tw-text-sm"
            :class="{ 'tw-text-noraLightBlue-200': focus || hovered }"
          >
            {{ group.Text }}
          </span>
          <ChevronDownIcon
            :class="{
              'tw-transform tw-rotate-180 ': isExpanded,
              'tw-text-noraLightBlue-200 ': focus || hovered,
            }"
            class="tw-h-5 tw-w-5 tw-ml-1"
            aria-hidden="true"
          />
        </span>
      </template>

      <template #default>
        <div class="tw-pb-3 tw-pl-1 tw-pt-1">
          <template v-for="(item, index) in group.Items" :key="index">
            <div class="tw-relative">
              <Checkbox
                v-if="group.Type === 'Checkbox'"
                :item="item"
                :group="group"
                :name="item.Text"
                :index="index"
                @filter-change="emitFilterChange"
              ></Checkbox>
              <Radio
                v-if="group.Type === 'Radio'"
                :radioGroupName="group.Group"
                :group="group"
                :item="item"
                :index="index"
                :class="{ 'tw-mr-10': item.HelperText }"
                @filter-change="emitFilterChange"
              >
              </Radio>
              <Accordion
                :toggleClasses="[
                  'tw-absolute',
                  'tw-right-2',
                  group.Group === 'ColorGroupName' ? 'tw-top-2' : 'tw-top-0',
                ]"
                @open="updateGroupAccordionHeight"
                v-if="item.HelperText"
              >
                <template #button-content="{ isExpanded, hovered }">
                  <InformationCircleIcon
                    class="tw-w-5 tw-h-5 tw-text-noraGray-200"
                    :class="{
                      'tw-text-noraGray-600': isExpanded,
                      'tw-text-noraGray-400': hovered,
                    }"
                  />
                </template>

                <template #default>
                  <p
                    class="tw-text-xs"
                    :class="{ 'tw-pl-6': group.Group !== 'ColorGroupName' }"
                  >
                    {{ item.HelperText }}
                  </p>
                </template>
              </Accordion>
            </div>
          </template>
        </div>
      </template>
    </accordion>
  </template>
</template>
<script>
import Checkbox from "./Checkbox.vue";
import Radio from "./Radio.vue";
import Accordion from "../Accordion.vue";
import { ChevronDownIcon, InformationCircleIcon } from "@heroicons/vue/solid";

export default {
  name: "FilterGroup",
  emits: ["filterChange"],
  components: {
    Checkbox,
    Radio,
    Accordion,
    ChevronDownIcon,
    InformationCircleIcon,
  },
  methods: {
    emitFilterChange(filterObject) {
      this.$emit("filterChange", filterObject);
    },
    updateGroupAccordionHeight() {
      // wait until the accordion animation is finished before updating the maximum height
      setTimeout(() => {
        this.$refs.groupAccordion.updateMaxHeight();
      }, 100);
    },
  },
  props: {
    headline: String,
    group: Object,
    alwaysOpen: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      accordionOpen: false,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
